"use strict";

/**
 * Global variables
 **/
const carouselWrappers = document.querySelectorAll(".content-tile-carousel-tabs-wrapper");

/**
 * Reset carousel states
 **/
const resetCarouselstates = (carouselElements) => {
    if (!carouselElements) {
        return false;
    }

    carouselElements.forEach(carouselElement => {
        carouselElement.classList.add("d-none");
    });
};

/**
 * Function that sets the defaults when page loads
 **/
const toggleActiveCarousel = (carouselElements, index) => {
    if (!carouselElements) {
        return false;
    }

    resetCarouselstates(carouselElements);
    index ? carouselElements[index].classList.remove("d-none") : carouselElements[0].classList.remove("d-none");
    const currentCarousel = $(carouselElements[index]).find(".slick-slider");
    currentCarousel.slick("unslick").slick();
};

/**
 * Function that sets the active tab
 **/
const setActiveTab = (tabsElements, index) => {
    if (!tabsElements) {
        return false;
    }

    tabsElements.forEach(tab => {
        tab.classList.remove("active");
    });

    tabsElements[index].classList.add("active");
};

/**
 * Events of the component
 **/
const bindEvents = () => {
    if (!carouselWrappers) {
        return false;
    }

    carouselWrappers.forEach(carouselWrapper => {
        const tabs = carouselWrapper.querySelectorAll(".carousel-tab-title");
        const carousels = carouselWrapper.querySelectorAll(".experience-commerce_assets-contenttilescarousel");
        const featuredTabs = carouselWrapper.querySelectorAll(".featured-tab-title");
        const isFeatured = carouselWrapper.querySelector(".featured-tile");
        const initialTabs = carouselWrapper.querySelector(".carousel-tabs-title-wrapper:not(.featured-tabs)");
        const interestedIn = document.querySelector(".interested-val").value;

        if (isFeatured) {
            initialTabs.classList.add("hidden");
        }

        toggleActiveCarousel(carousels);

        if (tabs) {
            tabs.forEach((tab, index) => {
                tab.addEventListener("click", () => {
                    setActiveTab(tabs, index);
                    toggleActiveCarousel(carousels, index);
                });

                if (interestedIn && interestedIn === "womenswear" && index !== 0) {
                    tab.click();
                }
            });
        }

        if (featuredTabs) {
            carouselWrapper.querySelectorAll(".featured-tab-title").forEach((tab, index) => {
                tab.classList.remove("active");
                if (index === featuredTabs.length - 1 || index === 0) {
                    tab.classList.add("active");
                }
            });

            featuredTabs.forEach((featuredTab) => {
                featuredTab.addEventListener("click", () => {
                    const targetTabClass = featuredTab.classList.contains("first") ? "first" : "second";
                    tabs.forEach((tab) => {
                        if (tab.classList.contains(targetTabClass)) {
                            tab.click();
                        }
                    });
                });
            });
        }
    });
};

module.exports = {
    bindEvents
};
